export const ALL_PROJECTS_VALUE = '__all__'
